// extracted by mini-css-extract-plugin
export default {"container":"pvpvyA","video":"oAiiP3","videoQuote":"Y1khwJ","oysterBackground":"CSm9uw","ctaPadding":"VlEMYj"};